/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PccE2eFixtureResetResponse
 */
export interface PccE2eFixtureResetResponse {
    /**
     *
     * @type {string}
     * @memberof PccE2eFixtureResetResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the PccE2eFixtureResetResponse interface.
 */
export function instanceOfPccE2eFixtureResetResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccE2eFixtureResetResponseFromJSON(json: any): PccE2eFixtureResetResponse {
    return PccE2eFixtureResetResponseFromJSONTyped(json, false);
}

export function PccE2eFixtureResetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function PccE2eFixtureResetResponseToJSON(value?: PccE2eFixtureResetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}
